import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaEdit, FaTrashAlt, FaQrcode } from "react-icons/fa";
import OperatorAccessModal from "./OperatorAccessModal";
import "./OperatorPlanQuotaBar.css";
import "./OperatorStatus.css";

function isAlertPending(pending) {
  return Boolean(pending && pending.code && !pending.acknowledged);
}

const Card_operator = (props) => {
  const {
    operator,
    showPlanBadges,
    onRequestDelete,
    autoOpenAccess,
    onAccessViewed,
  } = props;
  const [accessOpen, setAccessOpen] = useState(Boolean(autoOpenAccess));
  const ignoreOpenUntil = useRef(0);
  const dismissedRef = useRef(false);
  const pending =
    operator.access_pending && operator.access_pending.code
      ? operator.access_pending
      : null;
  const alertPending = isAlertPending(pending);

  useEffect(() => {
    if (autoOpenAccess && alertPending && !dismissedRef.current) {
      setAccessOpen(true);
    }
  }, [autoOpenAccess, alertPending]);

  function handleDeleteClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (onRequestDelete) {
      onRequestDelete(operator);
    }
  }

  function openAccess(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (Date.now() < ignoreOpenUntil.current) {
      return;
    }
    if (pending) {
      setAccessOpen(true);
    }
  }

  function closeAccess(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    dismissedRef.current = true;
    ignoreOpenUntil.current = Date.now() + 400;
    if (onAccessViewed && pending && !pending.acknowledged) {
      onAccessViewed(operator);
    }
    window.setTimeout(() => setAccessOpen(false), 50);
  }

  return (
    <div className="col-sm-12  col-md-6 col-lg-6">
      <div className="container">
        <div
          className={
            "x_panel_no_width col-xs-12 z-depth-2" +
            (operator.plan_included ? " operator-card--licensed" : "") +
            (operator.telemetry_online && !alertPending
              ? " operator-card--online"
              : "") +
            (alertPending ? " operator-card--access-pending" : "")
          }
        >
          <a className="pull-left border-aero">
            <img
              src={operator.thumbnail}
              className="img-circle profile_img"
              id="img-circle"
              alt="..."
            />
          </a>
          <div className="media-body">
            <div className="pull-right operator-card-actions">
              {alertPending ? (
                <button
                  type="button"
                  className="btn btn-link operator-access-alert"
                  onClick={openAccess}
                  title={props.t("Pedido de acesso do app")}
                  aria-label={props.t("Pedido de acesso do app")}
                >
                  <FaQrcode />
                </button>
              ) : null}
              <Link to={operator.id + "/change"}>
                <FaEdit />
              </Link>
              <button
                type="button"
                className="btn btn-link"
                onClick={handleDeleteClick}
                title={props.t("Excluir operador")}
                aria-label={props.t("Excluir operador {{name}}", {
                  name: operator.nome,
                })}
                style={{ padding: 0, border: 0, background: "none" }}
              >
                <FaTrashAlt />
              </button>
            </div>
            <div className="container-fluid col-md-offset-1">
              <h4>
                <span
                  className={
                    operator.telemetry_online
                      ? "operator-status-dot operator-status-dot--online"
                      : "operator-status-dot"
                  }
                  title={
                    operator.telemetry_online
                      ? props.t("Telemetria ligada no app")
                      : props.t("Telemetria desligada")
                  }
                  aria-label={
                    operator.telemetry_online
                      ? props.t("Telemetria ligada no app")
                      : props.t("Telemetria desligada")
                  }
                />
                {pending ? (
                  <button
                    type="button"
                    className={
                      "operator-access-name" +
                      (alertPending ? "" : " operator-access-name--seen")
                    }
                    onClick={openAccess}
                    title={
                      alertPending
                        ? props.t("Clique para liberar o acesso do app")
                        : props.t(
                            "Este operador tentou acessar o app. Clique para ver o código de novo."
                          )
                    }
                  >
                    {operator.nome}
                    {alertPending ? (
                      <span className="operator-access-pill">
                        {props.t("Tentando conectar")}
                      </span>
                    ) : null}
                  </button>
                ) : (
                  operator.nome
                )}
                {showPlanBadges && operator.plan_included ? (
                  <span className="operator-card-plan-badge operator-card-plan-badge--included">
                    {props.t("Licença")}
                  </span>
                ) : null}
                {showPlanBadges && !operator.plan_included ? (
                  <span className="operator-card-plan-badge operator-card-plan-badge--extra">
                    {props.t("Adicional")}
                  </span>
                ) : null}
              </h4>

              {alertPending ? (
                <button
                  type="button"
                  className="operator-access-banner"
                  onClick={openAccess}
                >
                  {props.t(
                    "Este operador está pedindo acesso no app. Clique para ver o código e o QR."
                  )}
                </button>
              ) : null}

              <p>
                {props.t("Identificação")} : <b>{operator.ident}</b>
              </p>
              <p>
                {props.t("Telefone")} : <b>{operator.telefone}</b>
              </p>

              <div className="" align="right">
                <small>
                  {props.t("Cadastrado na fazenda")}:{" "}
                  <b>{operator.farm_name}</b>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      {accessOpen ? (
        <OperatorAccessModal
          pending={pending}
          operatorName={operator.nome}
          onClose={closeAccess}
        />
      ) : null}
    </div>
  );
};

export default withTranslation()(Card_operator);
